import { PromotionKind } from "common/types/promotions";

import { useFeatures } from "client/clinics/hooks";

import IncentivePage from "./IncentivePage";
import PromotionPage from "./PromotionPage";

const IncentivePageSwitch = () =>
  useFeatures().PROMOTION_PAGES_USE_PRODUCT_CARDS ? (
    <PromotionPage kind={PromotionKind.Incentive} />
  ) : (
    <IncentivePage />
  );

export default IncentivePageSwitch;
